"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const react_redux_1 = require("react-redux");
exports.default = (fn, ...cargs) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    return (0, react_1.useCallback)((...rargs) => (dispatch(fn(...cargs, ...rargs))), 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [fn, ...cargs, dispatch]);
};
